import { _id } from 'src/_mock/assets';

const MOCK_ID = _id[1];

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      refresh: `${ROOTS.AUTH}/jwt/refresh/`,
      changePassword: `${ROOTS.AUTH}/jwt/change-password`,
    },
  },
  // DASHBOARD
  dashboard: {
    changePassword: `${ROOTS.DASHBOARD}/change-password`,
    root: ROOTS.DASHBOARD,
    profile: `${ROOTS.DASHBOARD}/profile`,
    restaurants: `${ROOTS.DASHBOARD}/restaurants`,
    deliveries: `${ROOTS.DASHBOARD}/deliveries`,
    transactions: `${ROOTS.DASHBOARD}/transactions`,
    performance: {
      graphics: `${ROOTS.DASHBOARD}/performance-stats`,
      summary: `${ROOTS.DASHBOARD}/performance-summary`,
      details: (start_date: string, end_date: string) => `${ROOTS.DASHBOARD}/performance-details?start_date=${start_date}&end_date=${end_date}`,
      details_subadmin: `${ROOTS.DASHBOARD}/performance-details-list`,
    },
    foods: `${ROOTS.DASHBOARD}/foods`,
    settings: `${ROOTS.DASHBOARD}/settings`,
    selectedFoods: {
      foods: `${ROOTS.DASHBOARD}/selected-foods/foods`,
      foodDetails: (id: string) => `${ROOTS.DASHBOARD}/selected-foods/foods/${id}`,
      ingredients: `${ROOTS.DASHBOARD}/selected-foods/ingredients`,
      customers: `${ROOTS.DASHBOARD}/selected-foods/customers`,
      customerDetails: (id: string) => `${ROOTS.DASHBOARD}/selected-foods/customers/${id}`,
      stickers: `${ROOTS.DASHBOARD}/selected-foods/stickers`,
      printExcel: `${ROOTS.DASHBOARD}/selected-foods/print-excel`,
    },
    customers: {
      profile: (id: string) => `${ROOTS.DASHBOARD}/customers/${id}`,
      list: `${ROOTS.DASHBOARD}/customers`,
    },
    users: {
      list: `${ROOTS.DASHBOARD}/users`,
      profile: (id: string) => `${ROOTS.DASHBOARD}/users/${id}`,
    },
    sub_users: {
      list: `${ROOTS.DASHBOARD}/subusers`,
      create: `${ROOTS.DASHBOARD}/subusers/create`,
      profile: (id: string) => `${ROOTS.DASHBOARD}/subusers/${id}`,
    },
    restaurant: {
      create: `${ROOTS.DASHBOARD}/restaurants/create`,
      profile: (id: string) => `${ROOTS.DASHBOARD}/restaurants/${id}`,
      plan: {
        plans: `${ROOTS.DASHBOARD}/restaurants/plans`,
        add: (id: string) => `${ROOTS.DASHBOARD}/restaurants/${id}/plan`,
        edit: (id: string) => `${ROOTS.DASHBOARD}/restaurants/plan/${id}`,
      },
      food: {
        foods: `${ROOTS.DASHBOARD}/restaurants/foods`,
        add: (id: string) => `${ROOTS.DASHBOARD}/restaurants/${id}/food`,
        edit: (id: string) => `${ROOTS.DASHBOARD}/restaurants/food/${id}`
      },
      plangroup: {
        plangroups: `${ROOTS.DASHBOARD}/restaurants/plangroups`,
        // TODO: add these pages when it's ready from the backend
        add: (restaurantId: string) => `${ROOTS.DASHBOARD}/restaurants/${restaurantId}/plangroup`,
        edit: (restaurantId: string, id: string) => `${ROOTS.DASHBOARD}/restaurants/${restaurantId}/plangroups/${id}`,
      },
      subscription: {
        subscriptions: `${ROOTS.DASHBOARD}/restaurants/subscriptions`,
        add: (restaurantId: string) => `${ROOTS.DASHBOARD}/restaurants/${restaurantId}/subscriptions/add`,
        edit: (restaurantId: string, id: string) => `${ROOTS.DASHBOARD}/restaurants/${restaurantId}/subscriptions/${id}`,
      },
      discount: {
        discounts: '/dashboard/restaurants/discounts',
      },
    },
    user: {
      root: `${ROOTS.DASHBOARD}/restaurants`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id: string) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },

  },
};
